import DateRangeWithShortcuts from '@/components/DateRangeWithShortcuts';
import { DateRange } from '@mui/x-date-pickers-pro';
import { Moment } from 'moment';
import { memo, useEffect, useState } from 'react';
import { getDefaultDateRange } from '../constants';

interface IProps {
  handleDaysInRangeChange: (daysInRange: number) => void;
}

const EstimationDatePicker = memo(({ handleDaysInRangeChange }: IProps) => {
  const [dateRange, setDateRange] = useState<DateRange<Moment>>(getDefaultDateRange());

  useEffect(() => {
    const [startDate, endDate] = dateRange;
    if (startDate && endDate) {
      handleDaysInRangeChange(endDate.diff(startDate, 'days') + 1);
    }
  }, [dateRange, handleDaysInRangeChange]);

  return (
    <DateRangeWithShortcuts
      value={dateRange}
      onChange={setDateRange}
      inputProps={{ sx: { backgroundColor: 'white', borderRadius: '8px' } }}
    />
  );
});

export default EstimationDatePicker;
